import { connect } from 'react-redux';
import styles from './HomeProducts.module.css';
import * as actions from '../../store/actions/index';
import Spinner from '../Spinner/Spinner';
import { useEffect } from 'react';
import FlexContainer from "../UI/FlexContainer/FlexContainer"
import ProductCard from '../ProductCard/ProductCard';
const SearchProducts = (props) => {

    let isLoaded = props.searchProductData !== null;   

    // useEffect(() => {
    //     if (!isLoaded) {
    //         console.log("home products request sent to server")
    //         props.fetchHomeProducts();
    //     }
    // }, []) 

    useEffect(()=>{
        props.onFetchWishlist(props.userId)
    },[])

    if (props.loading) {
        return (<div className={styles.Spinner}>
            <Spinner />
        </div>)
    }
 
    if (!isLoaded) {
        return null;
    }

    return (
        <div className="container container-md" style={{ padding: "20px" }}>
            

                        <FlexContainer>
                            {
                                props.searchProductData.map(product=>(
                                    <ProductCard product={product}/>
                                ))
                            }

                               

                        </FlexContainer>
 
          
        </div>
    );

} 

const mapStateToProps = (state) => {
    return {
        productData: state.homeProducts.productData,
        searchProductData:state.homeProducts.searchProductData,
        loading: state.homeProducts.loading,
        userId:state.auth.userId
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchHomeProducts: () => dispatch(actions.fetchHomeProducts()),
        onFetchWishlist: (userId) => dispatch(actions.onFecthWishlist(userId)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SearchProducts);

